//enum auxiliar para classificar os proventos

const PROVENTO_TIPO = {
    LOT: { id: 'LOT', descricao: 'Troca de Lote' },
    DIV: { id: 'DIV', descricao: 'Dividendo' },
    RCD: { id: 'RCD', descricao: 'Restituição de Capital em Dinheiro' },
    RCA: { id: 'RCA', descricao: 'Restituição de Capital em Ações' },
    RCRA: { id: 'RCRA', descricao: 'Restituição de Capital com Redução do número de Ações' },
    BOND: { id: 'BOND', descricao: 'Bonificação em Dinheiro' },
    BONI: { id: 'BONI', descricao: 'Bonificação' },
    JCP: { id: 'JCP', descricao: 'Juros sobre Capital Próprio' },
    JRF: { id: 'JRF', descricao: 'Juros sobre Renda Fixa' },
    REN: { id: 'REN', descricao: 'Rendimento' },
    AMRF: { id: 'AMRF', descricao: 'Amortização Renda Fixa' },
    PRRF: { id: 'PRRF', descricao: 'Prêmio Renda Fixa' },
    CM: { id: 'CM', descricao: 'Atualização Monetária' },
    DES: { id: 'DES', descricao: 'Desdobramento' },
    GRU: { id: 'GRU', descricao: 'Grupamento' },
    SUB: { id: 'SUB', descricao: 'Subscrição' },
    PRSUB: { id: 'PRSUB', descricao: 'Prioridade de Subscrição' },
    EXSUB: { id: 'EXSUB', descricao: 'Exercício de Subscrição' },
    SUBRE: { id: 'SUBRE', descricao: 'Subscrição com Renúncia do Direito de Preferência' },
    INC: { id: 'INC', descricao: 'Incorporação' },
    FUS: { id: 'FUS', descricao: 'Fusão' },
    CIS: { id: 'CIS', descricao: 'Cisão com Redução do Capital Social' },
    CISA: { id: 'CISA', descricao: 'Cisão com Redução do Capital Social e da Quantidade de Ações' },
    ATU: { id: 'ATU', descricao: 'Atualização' },
    RGTRFP: { id: 'RGTRFP', descricao: 'Resgate Parcial Renda Fixa' },
    RGTRF: { id: 'RGTRF', descricao: 'Resgate Total Renda Fixa' },
    RGTRV: { id: 'RGTRV', descricao: 'Resgate Total Renda Variável' }
};

module.exports = PROVENTO_TIPO;
